interface CompassLogoProps {
  size?: string; // Tailwind size class e.g. "w-6 h-6"
  className?: string;
}

export default function CompassLogo({ size = "w-6 h-6", className = "" }: CompassLogoProps) {
  return (
    <svg viewBox="0 0 120 120" className={`${size} ${className}`}>
      <circle cx="60" cy="60" r="55" fill="none" stroke="hsl(var(--gold))" strokeWidth="1.5" opacity="0.6" />
      <circle cx="60" cy="60" r="50" fill="none" stroke="hsl(var(--gold))" strokeWidth="0.5" opacity="0.3" />
      <polygon points="60,10 64,50 60,45 56,50" fill="hsl(var(--gold))" opacity="0.9" />
      <polygon points="60,110 64,70 60,75 56,70" fill="hsl(var(--gold-dim))" opacity="0.6" />
      <polygon points="10,60 50,56 45,60 50,64" fill="hsl(var(--gold-dim))" opacity="0.6" />
      <polygon points="110,60 70,56 75,60 70,64" fill="hsl(var(--gold-dim))" opacity="0.6" />
      <line x1="25" y1="25" x2="45" y2="45" stroke="hsl(var(--gold))" strokeWidth="0.8" opacity="0.4" />
      <line x1="95" y1="25" x2="75" y2="45" stroke="hsl(var(--gold))" strokeWidth="0.8" opacity="0.4" />
      <line x1="25" y1="95" x2="45" y2="75" stroke="hsl(var(--gold))" strokeWidth="0.8" opacity="0.4" />
      <line x1="95" y1="95" x2="75" y2="75" stroke="hsl(var(--gold))" strokeWidth="0.8" opacity="0.4" />
      <circle cx="60" cy="60" r="5" fill="hsl(var(--gold))" opacity="0.8" />
      <circle cx="60" cy="60" r="2" fill="hsl(var(--background))" />
      {Array.from({ length: 12 }).map((_, i) => {
        const angle = (i * 30 * Math.PI) / 180;
        const r1 = 47;
        const r2 = 50;
        return (
          <line
            key={i}
            x1={60 + r1 * Math.sin(angle)}
            y1={60 - r1 * Math.cos(angle)}
            x2={60 + r2 * Math.sin(angle)}
            y2={60 - r2 * Math.cos(angle)}
            stroke="hsl(var(--gold))"
            strokeWidth="0.8"
            opacity="0.5"
          />
        );
      })}
      <text x="60" y="23" textAnchor="middle" fill="hsl(var(--gold))" fontSize="7" fontFamily="Cinzel, serif" fontWeight="700" opacity="0.9">C</text>
      <text x="97" y="63" textAnchor="middle" fill="hsl(var(--gold))" fontSize="7" fontFamily="Cinzel, serif" fontWeight="700" opacity="0.9">O</text>
      <text x="60" y="103" textAnchor="middle" fill="hsl(var(--gold))" fontSize="7" fontFamily="Cinzel, serif" fontWeight="700" opacity="0.9">E</text>
      <text x="23" y="63" textAnchor="middle" fill="hsl(var(--gold))" fontSize="7" fontFamily="Cinzel, serif" fontWeight="700" opacity="0.9">R</text>
    </svg>
  );
}
